import { render } from "./OrderMap.vue?vue&type=template&id=c4607e4a"
import script from "./OrderMap.vue?vue&type=script&lang=js"
export * from "./OrderMap.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__